import { render, staticRenderFns } from "./marketSpecPrice_page.vue?vue&type=template&id=27a9a45f&scoped=true"
import script from "./marketSpecPrice_page.vue?vue&type=script&lang=js"
export * from "./marketSpecPrice_page.vue?vue&type=script&lang=js"
import style0 from "./marketSpecPrice_page.vue?vue&type=style&index=0&id=27a9a45f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9a45f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a9a45f')) {
      api.createRecord('27a9a45f', component.options)
    } else {
      api.reload('27a9a45f', component.options)
    }
    module.hot.accept("./marketSpecPrice_page.vue?vue&type=template&id=27a9a45f&scoped=true", function () {
      api.rerender('27a9a45f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/marketSpecPrice_page.vue"
export default component.exports